export const GET_USER = "get_user";
export const GET_USER_SUCCESSFUL = "get_user_successful";

// export const ADD_MENU = "add_menu";
// export const PUT_MENU = "put_menu";
// export const DELETE_MENU = "delete_menu";

export const USER_CHANGE_PASSWORD="User_Change_password"

export const API_ERROR = "api_failed";
